import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import emoji from "../assets/images/hiemoji.png";
import dashboard_dark from "../assets/images/dashboard_dark.png";
import bell from "../assets/images/bell.svg";
import { ModalPortal } from "./ModalPortal";
import { CustomModal } from "../shared/CustomModal";
import { useLayoutEffect } from "react";
import { allClasses } from "../Store/api/activities";
import { ProfileDropdown } from "../shared/ProfileDropdown";

const StudentNavbar = ({ sideBarEvent, setSideBarEvent = () => {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dueClasses, setDueClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { user } = useSelector((state) => state.auth);

  useLayoutEffect(() => {
    dispatch(
      allClasses({
        onSuccess: (res) => {
          setDueClasses(res.data);
        },
        onError: () => {},
      })
    );
  }, []);

  const onToggle = () => setShowModal((prev) => !prev);
  const handleAction = () => {
    const { sections = [] } = dueClasses?.[0] || {};
    const { 0: currentClass } = sections;
    if(currentClass?.joinCode)
      navigate(`/section/${currentClass.joinCode}?tab=${2}`);
    
    else onToggle();
  };

  return (
    <>
      <ModalPortal>
        <CustomModal
          onHide={onToggle}
          showModal={showModal}
          onAction={handleAction}
          cancelBtnText="Go back"
          actionBtnText="Subscribe to Greyled"
          title="subscribe to greyled to complete activites"
          content="Our mission is to be financially accessible to all students while providing features to improve learning and easy access to grades. Subscribe to Greyled to view and complete assigned activities."
        />
      </ModalPortal>
      <nav className="navbar navbar-default dashboard_header">
        <div className="navbar-header w-100 d-flex align-items-center justify-content-between">
          <h1 className="hi_user cursor_default">
            {sideBarEvent === "overview" ? (
              <>
                Hi {user.firstName}{" "}
                <img style={{ marginBottom: "10px" }} src={emoji} alt="empji" />
              </>
            ) : (
              <>
                {user.firstName} {sideBarEvent}
              </>
            )}
          </h1>
          <div className="d-flex align-items-center gap-120">
            <button
              className="subscribe-btn fs-14 text-center fst-normal fw-semibold"
              onClick={onToggle}
            >
              Subscribe
            </button>
            <div className="right_bar gap-3 me-3">
              <Link
                className="cursor text-decoration-none"
                to={"/studentlearn"}
              >
                <img src={dashboard_dark} alt="grid" width={24} height={24} />
              </Link>
              <div className="cursor">
                <img src={bell} alt="grid" className="bell cursor" />
              </div>
              <div className="cursor">
                <ProfileDropdown user={user} from="student" />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default StudentNavbar;
